import { call, put, take } from 'redux-saga/effects';
import api from 'services';
import * as actionTypes from 'constants/ActionTypes';

/**
 * Get annotations by text
 * */
export function* postAnnotations(text, typeLetter, selectedServer, options) {
    const response = yield call(api.postAnnotations, text, typeLetter, selectedServer, options);

    if (response.status === 200) {
        yield put({
            type: actionTypes.POST_ANNOTATIONS.SUCCESS,
            data: response.data.annotations,
            headers: response.headers,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: 'Annotations obtain',
                level: 'success',
                _id: new Date().getMilliseconds(),
                autoDismiss: 2,
            },
        });

        return response;
    }

    yield put({
        type: actionTypes.POST_ANNOTATIONS.FAILURE,
    });

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Error',
            message: 'Something get wrong',
            level: 'error',
            _id: new Date().getMilliseconds(),
            autoDismiss: 99999,
        },
    });

    return response;
}

export function* watchPostAnnotations() {
    while (true) {
        const { text, typeLetter, selectedServer, options } = yield take(actionTypes.POST_ANNOTATIONS.REQUEST);

        try {
            yield call(postAnnotations, text, typeLetter, selectedServer, options);
        } catch (error) {
            console.dir(error);
        }
    }
}

export default [
    watchPostAnnotations,
];



// WEBPACK FOOTER //
// ./app/sagas/annotations.js